module.exports = __webpack_public_path__ + "img/richangguanli.28e64ee1.png";